import 'slick-carousel';
import Swiper, { Navigation, Pagination } from 'swiper';

export default function () {

  $(function () {
    // PCメニュー アンカーリンク処理
    $(".js-page-scroll").on("click", (e) => {
      $("html").addClass('is-smooth');
    });

    // SPメニュー アンカーリンク処理
    $(".js-header-menu-link").on("click", (e) => {
      $(".close-menu").trigger("click");
      $(".close-cart-button").trigger("click");
      $("html").addClass('is-smooth');
    });

    // 初期表示の調整
    $(".wait-to-be-shown").addClass('is-ready');

    // タイトルからアイテムを探すのswiper
    const titleSwiper = new Swiper('.title-swiper', {
      slidesPerView: 'auto',
      freeMode: true,
      navigation: {
        nextEl: '.title-swiper-next',
        prevEl: '.title-swiper-prev',
      },
      on: {
        unlock: function () {
          $(".title-swiper").addClass('is-unlocked');
        },
        lock: function () {
          $(".title-swiper").removeClass('is-unlocked');
        },
      },
    });

    // タイトルからアイテムを探すのITEM切り替え
    $(".work-title-list li").on('click',function(){
      const index = $(".work-title-list li").index(this);
      $(".work-title-list li").removeClass("active");
      $(this).addClass("active");

      $(".title-detail-list-container .title-detail").removeClass("active");
      $(".title-detail-list-container .title-detail").eq(index).addClass("active");

      $(".title-showup").css({"background-image":"url("+$(this).attr("data-bgimg")+")"});
    });

    // タイトルからアイテムを探すの背景切り替え
    $(".title-showup").css({"background-image":"url("+$(".work-title-list li.active").attr("data-bgimg")+")"});

    // NEW TITLE swiper
    const newTitleSwiper = new Swiper('.new-title-swiper', {
      slidesPerView: 2.1,
      spaceBetween: 15,
      slidesPerGroup: 2,
      breakpoints: {
        901: {
          slidesPerView: 4,
          spaceBetween: 15,
          slidesPerGroup: 4,
        },
      },
      navigation: {
        nextEl: '.new-title-swiper-next',
        prevEl: '.new-title-swiper-prev',
      },
      pagination: {
        el: '.new-title-swiper-pagination',
        clickable: true,
      },
    });

    // STUDIO swiper
    const studioListSwiperCount = $('.studio-list-swiper .swiper-slide').length;
    const slideWidth = 267.5;
    const slideMarginRight = 15;
    const slideBlockPadding = 16;
    const slideBlockWidth = slideWidth * studioListSwiperCount + slideMarginRight * (studioListSwiperCount - 1) + slideBlockPadding;
    $('.studio-list-swiper-block').css('max-width', slideBlockWidth + 'px');

    const studioListSwiper = new Swiper('.studio-list-swiper', {
      slidesPerView: Math.min(2.1, studioListSwiperCount),
      spaceBetween: 15,
      slidesPerGroup: 1,
      slideToClickedSlide: true,
      loop: 1 < studioListSwiperCount, // スライド1枚のときはループしない
      breakpoints: {
        901: {
          slidesPerView: Math.min(4, studioListSwiperCount),
          spaceBetween: 15,
          slidesPerGroup: 1,
        },
      },
      navigation: {
        nextEl: '.studio-list-swiper-next',
        prevEl: '.studio-list-swiper-prev',
      },
    });
    const studioDetailSwiper = new Swiper('.studio-detail-swiper', {
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });
    studioListSwiper.on('slideChangeTransitionEnd', function() {
      const currentSlideIndex = $('.studio-list-swiper .swiper-slide-active').data('swiper-slide-index');
      studioDetailSwiper.slideTo(currentSlideIndex);
    });
    studioDetailSwiper.on('slideChangeTransitionEnd', function() {
      const currentDetailSlideIndex = $('.studio-detail-swiper .swiper-slide-active').index();
      studioListSwiper.slideToLoop(currentDetailSlideIndex, 0);
    });
  });
}

const heightChange = (e) => {
  const height = $(e).outerHeight()
  +$(".title-detail h2").outerHeight()
  +$(".title-production").outerHeight()
  +$(".title-pickup-list-container").outerHeight()
  +$(".title-category").outerHeight()
  return height;
}

$(function() {
  var count = 80;
  $('#l80').each(function() {
    var thisText = $(this).text();
     var textLength = thisText.length;
      if (textLength > count) {
         var showText = thisText.substring(0, count);
         var insertText = showText += '…';
         $(this).html(insertText);
     };
 });

});

